import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ServiceModes } from '../components/ServiceModes';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { AboutStory } from '../components/AboutStory';
import { ServiceAreas } from '../components/ServiceAreas';
import { Testimonials } from '../components/Testimonials';
import { BookingContact } from '../components/BookingContact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-brand-light font-body text-brand-dark" data-id="element-254">
      <Navbar data-id="element-255" />
      <main data-id="element-256">
        <Hero data-id="element-257" />
        <ServiceModes data-id="element-258" />
        <Services data-id="element-259" />
        <WhyChooseUs data-id="element-260" />
        <AboutStory data-id="element-261" />
        <ServiceAreas data-id="element-262" />
        <Testimonials data-id="element-263" />
        <BookingContact data-id="element-264" />
      </main>
      <Footer data-id="element-265" />
    </div>;
}